import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/ada-compliant-tax-credit")({
  beforeLoad: () => {
    throw redirect({ href: "/articles/ada-compliant-tax-credit", statusCode: 301 });
  },
});
